import { Tooltip } from "antd";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { TiArrowSortedDown } from "react-icons/ti";
import Select from "react-select";
import { renderTeamYears, useOnClickOutside } from "../../../../../utils";
import SearchBox from "../../../../common/Filter/SearchBox";
import { SettingsIcon } from "../../../../common/Icons";
import _ from "./../../../../../i18n";
import ConfigurePeriodModal from "./ConfigurePeriodModal";
import styles from "./index.module.scss";

export default function Filters({
  filters,
  options,
  setFilters,
  setSelectedFilter,
  bonusTypes,
  setBonusTypes,
  isSavingBonusTypes,
  handleSaveBonusTypes,
  isBonusTypesModalOpen,
  setIsBonusTypesModalOpen,
}) {
  const ref = useRef();
  useOnClickOutside(ref, () => setYearDivIsVisible(false));
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  // const [filter, setFilter] = useState(defaultFiltersValue);

  // useEffect(() => {
  //   setFilter((prevFilter) => {
  //     const updatedFilterTab = prevFilter.filterTab.map((tab) => {
  //       if (tab.id === "QUARTERLY") {
  //         return {
  //           ...tab,
  //           subTab: tab.subTab.map((subTab) => {
  //             const disabled = subTab.id > 1 ? moment().quarter() < subTab.id && moment().year() === year : false;
  //             console.log(disabled, moment().quarter() < subTab.id, moment().year() === year, subTab.id, moment().quarter(), moment().year(), year);
  //             return { ...subTab, disabled };
  //           }),
  //         };
  //       }
  //       return tab;
  //     });

  //     return {
  //       ...prevFilter,
  //       year,
  //       filterTab: updatedFilterTab,  // Ensure we set the updated filterTab
  //     };
  //   });
  // }, [year]);

  useEffect(() => {
    if (filters.period.id === "ANNUAL") {
      setSelectedFilter(filters.period);
    } else if (filters.period.id === "QUARTERLY") {
      setSelectedFilter(filters.subPeriod);
    }
  }, [filters]);

  const handleChangeYear = (year) => {
    setFilters({
      ...filters,
      year: year,
    });
  };

  const handleGeChange = (selectedOption) => {
    setFilters({ ...filters, encodingManager: selectedOption?.value });
  };

  const renderYearSelect = () => {
    return (
      <div
        ref={ref}
        className={
          "customed_select" +
          " " +
          (yearDivIsVisible ? "customed_select_opened" : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff",
        }}
      >
        <div className={"customed_select_header"}>
          <span>{filters.year}</span>
          <div className={"actions"}>
            <div>
              <span
                className={"action"}
                onClick={() => setYearDivIsVisible(!yearDivIsVisible)}
              >
                <TiArrowSortedDown />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={"customed_select_body"}>
            <div className={"customed_select_body_options"}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={"customed_select_body_option"}
                  onClick={() => {
                    handleChangeYear(item);
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.filter_container} style={{ width: "100%" }}>
      <div className={styles.row}>
        <div className={styles.period_container}>
          <Tooltip title="Configurer la period pour les types de bonus">
            <div
              className={styles.filter_config}
              onClick={() => setIsBonusTypesModalOpen(true)}
            >
              <SettingsIcon fill="#29394D" />
            </div>
          </Tooltip>

          {renderYearSelect()}

          <div className={styles.period_selector}>
            {filters.filterTab.map((item) => (
              <div
                key={item.id}
                className={classNames({
                  [styles.period_selector_item]: true,
                  [styles.period_selector_item_active]:
                    filters.period.id === item.id,
                })}
                onClick={() => {
                  setFilters({
                    ...filters,
                    period: item,
                    subPeriod: "ANNUAL" !== item.id ? item.subTab[0] : null,
                  });
                }}
              >
                {_(item.label)}
              </div>
            ))}
          </div>
        </div>

        <div>
          <SearchBox
            placeholder={_("search")}
            onChange={(item) => setFilters({ ...filters, keyWord: item })}
            filter={filters}
            nbResult={filters.nbResult}
            height={40}
          />

          <Select
            isSearchable
            closeMenuOnSelect
            placeholder={_("collaborator")}
            options={options}
            value={options.find((ge) => ge.value === filters.encodingManager)}
            onChange={handleGeChange}
            styles={customStyles}
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.sub_period_selector}>
          {"ANNUAL" !== filters.period.id && (
            <div className={styles.sub_period_selector_items}>
              {filters.period.subTab.map((tab) => {
                return (
                  <div
                    key={tab.id}
                    className={classNames({
                      [styles.item_tag]: true,
                      [styles.item_active]: filters.subPeriod.id === tab.id,
                      [styles.item_disabled]:
                        tab.disabled && filters.period.id === "QUARTERLY",
                    })}
                    onClick={() =>
                      !tab.disabled
                        ? setFilters({ ...filters, subPeriod: tab })
                        : null
                    }
                  >
                    {tab.label}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <ConfigurePeriodModal
        open={isBonusTypesModalOpen}
        handleOpen={(openStatus) => setIsBonusTypesModalOpen(openStatus)}
        bonusTypes={bonusTypes}
        setBonusTypes={setBonusTypes}
        isSavingBonusTypes={isSavingBonusTypes}
        handleSaveBonusTypes={handleSaveBonusTypes}
      />
    </div>
  );
}

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "40px",
    maxWidth: "244px",
    width: "244px",
    borderColor: state.isFocused ? "#2684FF" : "#cccccc",
    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
    "&:hover": {
      borderColor: "#2684FF",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#deebff"
      : "white",
    color: state.isSelected ? "white" : "#333",
    cursor: "pointer",
    fontSize: "14px",
    "&:active": {
      backgroundColor: "#2684FF",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
    fontSize: "15px",
  }),
};
